module.exports = __webpack_public_path__ + "static/media/mora-logo.d498358a.svg";